/** Settings, AI spending: every dollar the ticket summary has spent (moved off the Overview, Jeff 2026-10-25). Everyone can read it. */
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { AiUsage } from '../../components/overview/ai-usage';
import { overviewQuery } from '../../lib/queries';
import { describeRpcError } from '../../lib/rpc';

export const Route = createFileRoute('/settings/ai')({
  component: AiSpending,
});

function AiSpending() {
  const q = useQuery(overviewQuery());
  if (q.error) return <p className="text-body text-alert">{describeRpcError(q.error)}</p>;
  if (!q.data) return <p className="text-body text-ink-3">Loading</p>;
  return (
    <div className="@container/main max-w-[1120px]">
      <AiUsage ai={q.data.ai} days={q.data.days} />
    </div>
  );
}
